<ng-container *ngIf="formRef?.control as formRefControl">
  <h1 class="formSection__header">Weight & Placement Location</h1>
  <form [formGroup]="formRefControl" class="cmn-forms weightInfo">
    <!-- Row 1 -->
    <div class="formGrid__esvr formGrid__esvr--split">
      <!-- Tare Weight -->
      <div class="loadVolume">
        <div class="formSection__input">
          <h2 class="input__title">Tare Weight (Truck Weight)</h2>
          <div *ngIf="editing; else elseTareWeight">
            <input placeholder="Tare Weight" matInput type="number" value="{{ getFieldValue('tareWeight') }}"
              formControlName="tareWeight" />
          </div>
          <ng-template #elseTareWeight>
            <p>{{ getFieldValue('tareWeight') }} Tonne(s)</p>
          </ng-template>
        </div>
      </div>
      <!-- Gross Weight -->
      <div class="loadVolume">
        <div class="formSection__input">
          <h2 class="input__title">Gross Weight (Truck + Volume of Load)</h2>
          <div *ngIf="editing; else elseGrossWeight">
            <input placeholder="Gross Weight" matInput type="number" value="{{ getFieldValue('grossWeight') }}"
              formControlName="grossWeight" />
          </div>
          <ng-template #elseGrossWeight>
            <p>{{ getFieldValue('grossWeight') }} Tonne(s)</p>
          </ng-template>
        </div>
      </div>
      <!-- Net Weight -->
      <div class="loadVolume">
        <div class="formSection__input">
          <h2 class="input__title">Volume of Load (Net Weight)</h2>
          <p>{{ getFieldValue('grossWeight') > getFieldValue('tareWeight') ?
            (getFieldValue('grossWeight') - getFieldValue('tareWeight')).toFixed(2) : 0 }} Tonne(s)</p>
        </div>
      </div>
    </div>
    <!-- Row 2 -->
    <div class="formGrid__esvr formGrid__esvr--split">
      <!-- Placement -->
      <div class="loadVolume">
        <div class="formSection__input">
          <h2 class="input__title">Placement Location</h2>
          <div *ngIf="editing; else elsePlacementLocation">
            <input placeholder="Placement Location" matInput type="text"
              value="{{ getFieldValue('placementLocation') }}" formControlName="placementLocation" />
          </div>
          <ng-template #elsePlacementLocation>
            <p>{{ getFieldValue('placementLocation') }}</p>
          </ng-template>
        </div>
      </div>
      <!-- Excavation -->
      <div class="loadVolume">
        <div class="formSection__input">
          <h2 class="input__title">Excavation Location</h2>
          <div *ngIf="editing; else elseExcavationLocation">
            <input placeholder="Excavation Location" matInput type="text"
              value="{{ getFieldValue('excavationLocation') }}" formControlName="excavationLocation" />
          </div>
          <ng-template #elseExcavationLocation>
            <p>{{ getFieldValue('excavationLocation') }}</p>
          </ng-template>
        </div>
      </div>
      <div class="loadVolume">
        <div class="formSection__input">
          <h2 class="input__title">Customer BOL</h2>
          <div *ngIf="editing; else elseCustomerBOL">
            <input placeholder="Customer BOL" matInput type="text" value="{{ getFieldValue('customerBOL') }}"
              formControlName="customerBOL" />
          </div>
          <ng-template #elseCustomerBOL>
            <p>{{ getFieldValue('customerBOL') }}</p>
          </ng-template>
        </div>
      </div>
    </div>
  </form>
</ng-container>